import React, { Component } from 'react';
import './ImageLoader.css';
import classnames from 'classnames';
import PropTypes from 'prop-types';


export default class ImageLoader extends Component {
  static propTypes = {
    className: PropTypes.string
  }

  onLoad = (e) => {
    e.target.classList.remove('blur');
  }

  render() {
    return (
      <div className={classnames('image-loader', {
        [this.props.className]: this.props.className })}
      >
        <img {...this.props} className="blur" onLoad={this.onLoad} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ImageLoader/ImageLoader.js